import styled from 'styled-components';

interface StyledComponentProps {
    height?: number;
}

export const SpacingV = styled.div<StyledComponentProps>`
    height:${props => props.height}px
`; 

